



















import { defineComponent } from '@vue/composition-api'

interface Option {
  value: string
  label: string
}

interface Props {
  options: Option[]
}

export default defineComponent({
  props: {
    options: {
      required: true,
      type: Array
    }
  },
  setup(props: Props, { attrs: { value } }) {
    return {
      value
    }
  }
})
